// extracted by mini-css-extract-plugin
export default {"icon":"BTN_INFO_ZAMOWIENIA_icon__y7CXM","icon2":"BTN_INFO_ZAMOWIENIA_icon2__6AStM"};